import { useLocale, LOCALES } from '@/i18n/useLocale';
import { useTranslation } from 'react-i18next';

import styles from './SeletorIdioma.module.css';

export function SeletorIdioma() {
  const { t } = useTranslation([
    'common',
    'nav',
    'board',
    'articles',
    'analytics',
    'feeddrive',
    'config',
    'strategist',
  ]);
  const locale = useLocale((s) => s.locale);
  const setLocale = useLocale((s) => s.setLocale);

  return (
    <div
      className={styles.root}
      role="group"
      aria-label={t('common:labels.languageInterface', 'Idioma da interface')}
    >
      {LOCALES.map((l) => (
        <button
          key={l.value}
          type="button"
          className={`${styles.seg} ${locale === l.value ? styles.segActive : ''}`}
          aria-pressed={locale === l.value}
          onClick={() => setLocale(l.value)}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
